import { services as backboneService } from './backbone'
import FronthubError from './helpers/FronthubError'

const backboneServiceList = backboneService()

/**
 * Setup the service list according to the services configured in front-hub.config.js applying it to the backbone service list.
 * In order to use the correctly endpoint, this function create the endpoint property according to the environment
 * @param {string} environment
 */
export const setup = (services = [], environment = 'development') => {
  for (const service of services) {
    if (typeof service !== 'object') {
      throw new FronthubError(`services must be an array of objects`)
    }

    Object.defineProperty(service, 'endpoint', {
      get() {
        if (service.endpoints === undefined) {
          throw new FronthubError(
            `Service '${service.name}' must have the endpoints property as an object with the production URL.`,
          )
        }

        if (!service.endpoints.hasOwnProperty('production')) {
          console.warn(
            `front-hub: Service ${service.name} must have production endpoint`,
          )
        }

        if (environment === 'development') {
          return (
            service.endpoints[environment] ||
            `http://localhost:5000/${service.name}`
          )
        }

        return service.endpoints[environment] || service.endpoints.production
      },
    })
    backboneServiceList.push(service)
  }
}
